import { Injectable } from '@angular/core';
import { EmptyResponse, UserFollows, UsersService } from '@vestiaire/api-sdk-angular';
import { Store } from '@ngrx/store';
import { IAppState } from '@app/store';
import * as UserActions from '@app/core/user/store/actions/user.actions';
import * as localForage from 'localforage';
import { Observable } from 'rxjs/index';
import { HttpResponse } from '@angular/common/http';
import { fromPromise } from 'rxjs/internal/observable/fromPromise';
import * as FeedActions from '@app/+feed/store/actions';

@Injectable()
export class FollowingMemberService {
  followingMember = [];

  constructor(private store: Store<IAppState>, private usersService: UsersService) {}

  setFollowingMember() {
    fromPromise(localForage.getItem('followMembers')).subscribe(
      res => {
        if (!res) {
          this.usersService.getMemberFollows('me').subscribe(
            followMember => {
              Object.assign(this.followingMember, followMember.data);
              localForage.setItem('followMembers', this.followingMember);
              this.store.dispatch({
                type: UserActions.SET_USER_FOLLOW_MEMBER,
                payload: this.followingMember
              });
              this.store.dispatch({
                type: FeedActions.SET_USER_FOLLOW,
                payload: this.followingMember
              });
            },
            error => {}
          );
        } else {
          this.store.dispatch({
            type: UserActions.SET_USER_FOLLOW_MEMBER,
            payload: res
          });
        }
      },
      error => {
        console.log(error);
      }
    );
  }

  followMember(id: string): Observable<EmptyResponse> {
    this.addFollowMemberToLocalForage(id);
    return this.usersService.follow(id);
  }

  unFollowMember(id: string): Observable<HttpResponse<UserFollows>> {
    this.removeFollowMemberFromLocalForage(id);
    return this.usersService.unfollow(id);
  }

  addFollowMemberToLocalForage(idMember: string) {
    fromPromise(localForage.getItem('followMembers')).subscribe(
      res => {
        const newFollowingMember = Object.keys(res).map(index => {
          return res[index];
        });
        if (newFollowingMember.indexOf(idMember) === -1) {
          newFollowingMember.push(String(idMember));
        }
        this.store.dispatch({
          type: UserActions.ADD_USER_FOLLOW_MEMBER,
          payload: newFollowingMember
        });
        this.store.dispatch({
          type: FeedActions.SET_USER_FOLLOW,
          payload: idMember
        });
        localForage.setItem('followMembers', newFollowingMember);
      },
      error => {
        console.log(error);
      }
    );
  }

  removeFollowMemberFromLocalForage(idMember: string) {
    fromPromise(localForage.getItem('followMembers')).subscribe(
      res => {
        const newFollowingMember = Object.keys(res)
          .map(index => {
            return res[index];
          })
          .filter(item => {
            if (item !== idMember) {
              return item;
            }
          });
        this.store.dispatch({
          type: UserActions.REMOVE_USER_FOLLOW_MEMBER,
          payload: newFollowingMember
        });
        this.store.dispatch({
          type: FeedActions.SET_USER_UNFOLLOW,
          payload: idMember
        });
        localForage.setItem('followMembers', newFollowingMember);
      },
      error => {
        console.log(error);
      }
    );
  }
}
